import { createAction } from "redux-act";
export var savePage = createAction("[[async]] save page");
export var goBackOnePage = createAction("[[async]] go back one page");
export var slidePage = createAction("slide page");
export var changeQuestion = createAction("change question");
export var initSurvay = createAction("get survay data");
export var initSurvaySuccess = createAction("get survay data success");



//////////////////
// WEBPACK FOOTER
// ./src/pages/Survay/ducks/actions.ts
// module id = 115
// module chunks = 0